import { merge } from '../../../../utils/state';
import entity from '../../entities/grants/entity';
import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import { TYPES } from './actions';

const coreReducer = entity.getReducer();

const initialState = {
  grantCreation: {
    error: null,
    isLoading: false,
  },
  grantUpdation: {
    isLoading: false,
    error: null,
  },
  newUserDetails: {
    ...ReduxRestEntity.initialState,
  },
  newUserExistingGrants: {
    ...ReduxRestEntity.initialState,
  },
  isGrantsRefreshing: false,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GRANT_CREATION:
      return merge(state, {
        grantCreation: {
          error: null,
          isLoading: true,
        },
      });
    case TYPES.GRANT_CREATION_SUCCESS:
      return merge(state, {
        grantCreation: {
          ...state.grantCreation,
          isLoading: false,
        },
      });
    case TYPES.GRANT_CREATION_ERROR:
      return merge(state, {
        grantCreation: {
          error: action.payload,
          isLoading: false,
        },
      });
    case TYPES.GRANT_UPDATION:
      return merge(state, {
        grantUpdation: {
          isLoading: true,
          error: null,
        },
      });
    case TYPES.GRANT_UPDATION_SUCCESS:
      return merge(state, {
        grantUpdation: {
          ...state.updateGrant,
          isLoading: false,
        },
      });
    case TYPES.GRANT_UPDATION_ERROR:
      return merge(state, {
        grantUpdation: {
          isLoading: false,
          error: action.payload,
        },
      });
    case TYPES.NEW_USER_DETAILS:
      return merge(state, {
        newUserDetails: {
          data: {},
          error: null,
          isLoading: true,
        },
      });
    case TYPES.NEW_USER_DETAILS_SUCCESS:
      return merge(state, {
        newUserDetails: {
          ...state.newUserDetails,
          data: action.payload,
          isLoading: false,
        },
      });
    case TYPES.NEW_USER_DETAILS_ERROR:
      return merge(state, {
        newUserDetails: {
          data: null,
          error: action.payload,
          isLoading: false,
        },
      });
    case TYPES.NEW_USER_EXISTING_GRANTS:
      return merge(state, {
        newUserExistingGrants: {
          data: {},
          error: null,
          isLoading: true,
        },
      });
    case TYPES.NEW_USER_EXISTING_GRANTS_SUCCESS:
      return merge(state, {
        newUserExistingGrants: {
          ...state.newUserExistingGrants,
          data: action.payload,
          isLoading: false,
        },
      });
    case TYPES.NEW_USER_EXISTING_GRANTS_ERROR:
      return merge(state, {
        newUserExistingGrants: {
          data: null,
          error: action.payload,
          isLoading: false,
        },
      });
    case TYPES.SET_IS_GRANTS_REFRESHING:
      return merge(state, {
        isGrantsRefreshing: action.payload,
      });
    default:
      return coreReducer(state, action);
  }
};

export default reducer;
